module.exports = __webpack_public_path__ + "img/pdf-green.2cfcff59.svg";